import React, { useState } from 'react';
import type { LoginSectionProps, LoginFormData } from '../../types/travel-payment';

const LoginSection: React.FC<LoginSectionProps> = ({ onSubmit, className = '' }) => {
  const [formData, setFormData] = useState<LoginFormData>({
    username: '',
    password: ''
  });

  const [showPassword, setShowPassword] = useState(false);

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onSubmit(formData);
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  return (
    <div className={`integrated-section login-section ${className}`}>
      <h2 className="integrated-section-title">Access Portal</h2>
      <p className="integrated-section-subtitle">Enter your credentials to access the travel portal</p>
      
      <form className="integrated-section-form" onSubmit={handleSubmit}>
        <input
          type="text"
          name="username"
          placeholder="Username"
          value={formData.username}
          onChange={handleInputChange}
          className="integrated-section-input"
          required
        />
        
        <div className="integrated-password-container">
          <input
            type={showPassword ? 'text' : 'password'}
            name="password"
            placeholder="Password"
            value={formData.password}
            onChange={handleInputChange}
            className="integrated-section-input"
            required
          />
          <button
            type="button"
            onClick={togglePasswordVisibility}
            className="integrated-password-toggle"
          >
            {showPassword ? '👁️' : '👁️‍🗨️'}
          </button>
        </div>
        
        <button 
          type="submit" 
          className="integrated-section-button button-gradient"
        >
          Login
        </button>
      </form>
    </div>
  );
};

export default LoginSection;